"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Link = require("./Link");

var _Link2 = _interopRequireDefault(_Link);

var _MarkdownHelp = require("./MarkdownHelp");

var _MarkdownHelp2 = _interopRequireDefault(_MarkdownHelp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommentForm = function CommentForm(_ref) {
  var _ref$Link = _ref.Link,
      Link = _ref$Link === undefined ? _Link2.default : _ref$Link,
      _ref$MarkdownHelp = _ref.MarkdownHelp,
      MarkdownHelp = _ref$MarkdownHelp === undefined ? _MarkdownHelp2.default : _ref$MarkdownHelp,
      body = _ref.body,
      _ref$isShowingHelp = _ref.isShowingHelp,
      isShowingHelp = _ref$isShowingHelp === undefined ? false : _ref$isShowingHelp,
      autoFocus = _ref.autoFocus,
      contentPolicyUrl = _ref.contentPolicyUrl,
      commentError = _ref.commentError,
      onShowHelp = _ref.onShowHelp,
      onHideHelp = _ref.onHideHelp,
      onChangeBody = _ref.onChangeBody,
      onCancel = _ref.onCancel,
      onSubmit = _ref.onSubmit;
  return _react2.default.createElement(
    "form",
    {
      className: "usertext cloneable warn-on-unload",
      id: "form-t5_mza2",
      onSubmit: onSubmit
    },
    _react2.default.createElement("input", { name: "thing_id", type: "hidden", defaultValue: "t5_m" }),
    _react2.default.createElement(
      "div",
      { className: "usertext-edit md-container", style: {} },
      _react2.default.createElement(
        "div",
        { className: "md" },
        _react2.default.createElement("textarea", {
          cols: 1,
          "data-event-action": "comment",
          "data-type": "link",
          name: "text",
          rows: 1,
          defaultValue: body,
          autoFocus: autoFocus,
          onChange: onChangeBody
        })
      ),
      _react2.default.createElement(
        "div",
        { className: "bottom-area" },
        onShowHelp ? _react2.default.createElement(
          "span",
          { className: "help-toggle toggle", style: {} },
          isShowingHelp ? _react2.default.createElement(
            "a",
            {
              className: "option active",
              tabIndex: 100,
              onClick: onHideHelp
            },
            "hide help"
          ) : _react2.default.createElement(
            "a",
            {
              className: "option active",
              tabIndex: 100,
              onClick: onShowHelp
            },
            "formatting help"
          )
        ) : null,
        contentPolicyUrl ? _react2.default.createElement(
          Link,
          {
            className: "reddiquette",
            href: contentPolicyUrl,
            tabIndex: 100,
            target: "_blank"
          },
          "content policy"
        ) : null,
        commentError ? _react2.default.createElement(
          "span",
          { className: "error" },
          commentError
        ) : null,
        _react2.default.createElement(
          "div",
          { className: "usertext-buttons" },
          _react2.default.createElement(
            "button",
            { className: "save", type: "submit" },
            "save"
          ),
          _react2.default.createElement(
            "button",
            {
              className: "cancel",
              style: onCancel ? null : {
                display: "none"
              },
              onClick: onCancel,
              type: "button"
            },
            "cancel"
          )
        )
      ),
      isShowingHelp ? _react2.default.createElement(MarkdownHelp, null) : null
    )
  );
};

exports.default = CommentForm;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/CommentForm.js
// module id = 306
// module chunks = 0